import { render } from "./IntakePatientModal.vue?vue&type=template&id=26f80e03"
import script from "./IntakePatientModal.vue?vue&type=script&lang=js"
export * from "./IntakePatientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__